/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PreferPaymentMethodEnum {

    Paid = 'PAID',

    Cod = 'COD',

    Card = 'CARD'
}

